<div class="login-form-container">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8 logo-container">
        <div class="">
          <div class="logo-wrapper">
            <div class="logo">
              <div>
                <img *ngIf="configService.themeConfig && configService.themeConfig.LogoUrl" [src]="configService.themeConfig.LogoUrl" alt="Site Logo">
              </div>
            </div>
            <div class="logo-content" *ngIf="configService.themeConfig">
              <h1 *ngIf="configService.themeConfig.Heading">{{'userLogin.logoContent' | translate}}</h1>
              <h2 *ngIf="configService.themeConfig.SubHeading">{{configService.themeConfig.SubHeading}}</h2>
              <div class="small-description">
                <strong *ngIf="configService.themeConfig.TagLine">{{configService.themeConfig.TagLine}}</strong><br>
                <span *ngIf="configService.themeConfig.Description">{{'userLogin.smallDescription' | translate}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 login-form">
        <div id="login" class="form-container">
          <div id="login-row" class="justify-content-center align-items-center">
            <div id="login-box">
              <div id="login-column" class="login-column-c">
                <p class="text-center login-title">{{'userLogin.twoFactorAuthentication.title' | translate}}</p>
                <p>{{'userLogin.twoFactorAuthentication.desc' | translate}}</p>
                <br><br>
                <form [formGroup]="twoFactorAuth" novalidate>
                  <label for="code" class="text-info">{{'userLogin.twoFactorAuthentication.code' | translate}}<span class="error">*</span></label>
                  <input type="text" maxlength="6" class="form-control" formControlName="code" required
                  onkeypress='return event.charCode>-48 && event.charCode<=57' (keydown.space)="$event.preventDefault()"
                  [ngClass]="{ 'is-invalid': submitted && f.code.errors}">
                  <div *ngIf="submitted && f.code.invalid">
                    <div class="alert alert-danger" *ngIf="f.code.errors.required">{{'userLogin.twoFactorAuthentication.error' | translate}}</div>
                  </div>
                  <p>{{counter | minutesSeconds}}</p>
                  <br>
                  <div class="form-group">
                    <div>
                      <a (click)="resendAuthenticationCode()" [ngClass]="{'disable':isEnable}">
                      {{'userLogin.twoFactorAuthentication.resendCode' | translate}}
                      </a>
                    </div>
                    <div>
                      <button type="button" class="btn-login btn-bg-color" mat-flat-button (click)="signIn()" [disabled]="isValid">
                        <span>{{'userLogin.twoFactorAuthentication.signinbutton' | translate}}</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <span *ngIf="isDisplayError == true">{{ loginErrorMessage }}</span>
              <span *ngIf="isDisplayError == false" class="error-message invalid-feedback">{{ loginErrorMessage }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="footer-copyrights" id="cp">
  <!-- © {{fullyear}} SimpliAssess, All Rights Reserved. -->
  © {{fullyear}} {{'footer.text' | translate}}
</div>
